var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDebuggingWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    role: "img",
    "aria-label": "Debugging",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 19l4-6h8l4 6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 28h24v11c0 9-7 16-16 16s-16-7-16-16V28z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 32h8M44 32h8M14 44h8M42 44h8M30 8v5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 36,
    r: 1.5,
    fill: "#ffffff",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 36,
    r: 1.5,
    fill: "#ffffff",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28 45h8"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDebuggingWhite);
export default __webpack_public_path__ + "static/media/debugging-white.829b18a19347301189ba2e017d28f6ce.svg";
export { ForwardRef as ReactComponent };